import { SITE_URL } from "./seo";

/**
 * Build a HowTo + SoftwareApplication schema pair for a calculator tool page.
 * Feeds Google's rich-result eligibility (numbered step carousel + app card).
 */
export function buildToolSchemas(opts: {
  name: string;
  description: string;
  path: string;
  steps: { name: string; text: string }[];
  applicationCategory?: string;
}) {
  const url = `${SITE_URL}${opts.path}`;
  const howTo = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: opts.name,
    description: opts.description,
    totalTime: "PT2M",
    step: opts.steps.map((s, i) => ({
      "@type": "HowToStep",
      position: i + 1,
      name: s.name,
      text: s.text,
      url: `${url}#step-${i + 1}`,
    })),
  };
  const softwareApp = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: opts.name,
    url,
    applicationCategory: opts.applicationCategory ?? "FinanceApplication",
    operatingSystem: "Web Browser",
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
  };
  return [
    { type: "application/ld+json" as const, children: JSON.stringify(howTo) },
    { type: "application/ld+json" as const, children: JSON.stringify(softwareApp) },
  ];
}